.container {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.viewerFullscreen3States {
	position: fixed;
	inset: 0;
	z-index: calc(
		(var(--mantine-z-index-modal, 200) + var(--mantine-z-index-app, 100)) /
			2
	); /*Medium between modal and app*/
	width: 100vw;
	height: 100vh;
}
